<template>
  <a-table
    :pagination="pagination"
    :loading="listLoading"
    bordered
    rowKey="id"
    :columns="columns"
    class="tableFixBox"
    :data-source="list"
    :scroll="{ x: 'max-content' }"
    @change="changePage"
  >
    <template v-slot:type_text="{ record }">
       <div v-if="record.type == 1">代发明细</div>
       <div v-else>代发红包明细</div>
    </template>
    <template #action="{ record }">
      <div>
        <a-button
          type="link"
          v-if="record.down_url"
          @click="downloadForm(record.down_url)"
          >下载</a-button
        >
        <span class="s_c999" v-else>无</span>
      </div>
    </template>
  </a-table>
</template>
<script>
import { exportList} from "@/api/financial";
import { onMounted, reactive, toRefs } from "vue";
import { $iscode } from "@/utils/app";
import { message } from "ant-design-vue";
import config from "@/config";
const columns = [
  {
    title: "导出时间",
    dataIndex: "create_time",
    key: "create_time",
  },
  {
    title: "生成进度",
    dataIndex: "status_text",
    key: "status_text",
    slots: { customRender: "status_text" },
  },
  {
    title: "数据类型",
    dataIndex: "type_text",
    key: "type_text",
    slots: { customRender: "type_text" },
  },
  {
    title: "操作",
    dataIndex: "action",
    slots: { customRender: "action" },
  },
];
export default {
  name: "warehousTable",
  props: {
    type: {
      type: Number, 
      required: true 
    },
  },
  setup(props, { emit }) {
    const state = reactive({
      listLoading: false,
      list: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 5,
        defaultPageSize: 5,
        showSizeChanger: true,
        pageSizeOptions: ["5", "8", "10", "12"],
        showQuickJumper: true,
        showTotal: (total) => `共 ${total} 条`,
      },
      search: {
        page: 1,
        limit: 5,
      },
    });
    const downloadForm = (url) => {
      // var http = "";
      //   http =
      //     config.baseUrl[process.env.VUE_APP_type];
        window.open(url);
    };
    const methods = {
      async init() {
        state.listLoading = true;
        state.list = [];
        let res = await exportList({ ...state.search, type: props.type })
            .then((res) => res.data)
            .catch((error) => error);
        state.listLoading = false;
        if ($iscode(res)) {
            state.list = res.data.data || [];
            state.pagination.total = res.data.total || 0;
            state.pagination.current = res.data.current_page || 1;
            console.log("21", state.list);
        } else {
          message.error(res.msg);
        }
      },
      changePage(e) {
        state.pagination.pageSize = e.pageSize;
        state.pagination.current = e.current;
        state.search.page = e.current;
        state.search.limit = e.pageSize;
        methods.init();
      },
    };

    onMounted(() => {
      methods.init();
    });
    return {
      columns,
      ...toRefs(state),
      ...methods,
      downloadForm,
    };
  },
};
</script>
